import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import LocationsPage from '../pages/locations/page';
import LocationDetailPage from '../pages/locations/LocationDetailPage';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/locations',
    element: <LocationsPage />,
  },
  {
    path: '/locations/:slug',
    element: <LocationDetailPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
